import { render, staticRenderFns } from "./tizhibianshi-list.vue?vue&type=template&id=a2e7b7b8&scoped=true&"
import script from "./tizhibianshi-list.vue?vue&type=script&lang=ts&"
export * from "./tizhibianshi-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e7b7b8",
  null
  
)

export default component.exports